// Generated by CoffeeScript 2.7.0
var UrlHelper, adminUrlFor, extendJSON, generateQueryStr, generateUrlWithParams, namespaceUrlFor, parseArray, parseObject, parseUrl, parseValue, wrapRawLink;

parseObject = function(chain, val, reserveBlankValue = false) {
  return _.map(val, function(v, k) {
    var new_chain;
    if (val.hasOwnProperty(k)) {
      new_chain = `${chain}[${k}]`;
      if (_.isArray(v)) {
        return parseArray(new_chain, v, reserveBlankValue);
      } else if (_.isObject(v)) {
        return parseObject(new_chain, v);
      } else {
        return parseValue(new_chain, v);
      }
    }
  });
};

parseArray = function(chain, val, reserveBlankValue = false) {
  var new_chain;
  new_chain = `${chain}[]`;
  if (reserveBlankValue && _.isEmpty(val)) {
    return parseValue(chain, val);
  } else {
    return _.map(val, function(item) {
      if (_.isArray(item)) {
        return parseArray(new_chain, item, reserveBlankValue);
      } else if (_.isObject(item)) {
        return parseObject(new_chain, item);
      } else {
        return parseValue(new_chain, item);
      }
    });
  }
};

parseValue = function(chain, val) {
  return [`${encodeURIComponent(chain)}=${encodeURIComponent(_.isBlank(val) ? '' : val)}`];
};

generateQueryStr = function(data, reserveBlankValue = false) {
  if (_.isEmpty(data)) {
    return [];
  }
  return _.chain(data).reduce(function(query_str, v, k) {
    if (data.hasOwnProperty(k)) {
      query_str = _.isArray(v) ? query_str.concat(parseArray(k, v, reserveBlankValue)) : _.isObject(v) ? query_str.concat(parseObject(k, v)) : query_str.concat(parseValue(k, v));
    }
    return query_str;
  }, []).flatten().compact().value();
};

generateUrlWithParams = function(url, data = {}, reserveBlankValue = false) {
  var query_str;
  query_str = generateQueryStr(data, reserveBlankValue);
  if (_.isEmpty(query_str)) {
    return url;
  } else {
    if (/\?/.test(url)) {
      return `${url}&${query_str.join('&')}`;
    } else {
      return `${url}?${query_str.join('&')}`;
    }
  }
};

// path(string)
// params(object)
namespaceUrlFor = function(path, params = {}) {
  var urlPresenter;
  urlPresenter = parseUrl(path);
  params = _.extend({}, urlPresenter.params, params);
  return generateUrlWithParams(`/namespaces/${currentNamespace.id}/${urlPresenter.path}`, params);
};

parseUrl = function(url) {
  var decode, match, path, pl, qp, searchRegex, searches, urlParams;
  // Remove first slash
  url = url.replace(/^\//, '');
  qp = url.indexOf('?');
  if (qp === -1) {
    return {
      path: url,
      params: {}
    };
  } else {
    path = url.slice(0, qp);
    searches = url.slice(qp);
  }
  pl = /\+/g;
  searchRegex = /([^?&=]+)=?([^&]*)/g;
  decode = function(s) {
    return decodeURIComponent(s.replace(pl, ' '));
  };
  urlParams = {};
  while (match = searchRegex.exec(searches)) {
    urlParams[decode(match[1])] = decode(match[2]);
  }
  return {
    path: path,
    params: urlParams
  };
};

extendJSON = function(url) {
  return url.replace(/^(.+?)(\.json)*((?:[\#?].*)?)$/, '$1.json$3');
};

adminUrlFor = function(path, params = {}) {
  var urlPresenter;
  urlPresenter = parseUrl(path);
  params = _.extend({}, urlPresenter.params, params);
  return generateUrlWithParams(`/admin/${urlPresenter.path}`, params);
};

wrapRawLink = function(text) {
  var link_regex;
  // https://zhuanlan.zhihu.com/p/33335629
  link_regex = /((http[s]?|ftp):\/\/[^\s\/$.?#].[^\s(\u4e00-\u9fa5)]*)/g;
  return text.replace(link_regex, function(match) {
    return `<a href="${match}" target="_blank" onclick="event.stopPropagation()">${match}</a>`;
  });
};

export default UrlHelper = {generateQueryStr, generateUrlWithParams, parseUrl, namespaceUrlFor, adminUrlFor, extendJSON, wrapRawLink};
